<!--

    Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<div class="my-32 flex h-screen flex-col gap-2">
  <div class="flex gap-48 py-6 lg:gap-96">
    <h1 class="text-primary text-xl font-bold">{{ title }}</h1>
    <ods-button
      variant="ghost"
      size="fit"
      (clicked)="closeDialog()"
      dataTestId="close-search-dialog"
      ariaLabel="Dialogfenster schließen"
      icon="close"
    />
  </div>
  <alfa-search-zustaendige-stelle-form-container [label]="title" (searchResultSelected)="searchResultSelected($event)" />
</div>
